export enum SentryBreadcrumbsCategories {
  GATEWAY_REQUEST = "GATEWAY_REQUEST",
  GATEWAY_RESPONSE = "GATEWAY_RESPONSE",
  EXPOSED_EVENTS = "EXPOSED_EVENTS",
  THREE_DS = "THREE_DS",
  JWT_UPDATES = "JWT_UPDATES",
}
